import { PivotCollect } from './PivotCollect';
import { PivotReduce } from './PivotReduce';
import { PivotResult } from './PivotResult';
import { PivotFilter } from './PivotFilter';
import { PivotSort } from './PivotSort';
export class Pivot {
    constructor(engine, query) {
        this._engine = engine;
        this._query = query;
    }
    get engine() {
        return this._engine;
    }
    get query() {
        return this._query;
    }
    execute(model) {
        const result = new PivotResult(this.query);
        const collector = new PivotCollect(this.query, result);
        const reducer = new PivotReduce(this.query, model, result);
        const collectFilter = PivotFilter.makeCollectFilter(model, this.query);
        const reduceFilter = PivotFilter.makeReduceFilter(model, this.query);
        const sort = PivotSort.makePivotSort(model, this.query);
        this.engine.dataset.data.forEach((row, index) => {
            if (collectFilter(row)) {
                collector.collect(row, index);
            }
        });
        reducer.reduce();
        PivotFilter.executeReduceFilter(model, result, reduceFilter);
        PivotSort.executePivotSort(model, this.query, result, sort);
        return result;
    }
    executeSQL(model) {
        const result = new PivotResult(this.query);
        return result;
    }
}
